<div fxLayout="column" class="page-container">
  <div fxLayout="column" fxFlex="70" class="eon-backdrop" fxLayoutAlign="center center">
    <div fxLayoutAlign="end start" class="eon-logo" fxFlex="20">
      <mat-icon svgIcon="logo-red"></mat-icon>
    </div>
    <div class="splash-container" fxFlex="80">
      <h1>Are you tech to the core? <br> Prove it in our TechCore Quiz!</h1>
    </div>
  </div>
  <div fxFlex="30" fxLayout="column" class="selection-container" fxLayoutAlign="center center" fxLayoutGap="10px">
      <eon-ui-button fullWidth=true text="Play a fantastech game!" class="primary-button" (click)="navigateToSignUp()"></eon-ui-button>
      <eon-ui-button fullWidth=true rank=secondary text="Show the scoreboard" class="secondary-button" (click)="navigateToScoreboard()"></eon-ui-button>
  </div>
</div>
